import React from "react";

import { useNavigate } from "react-router-dom";  
const tickets = [
  {
    title: "Rainforest Wild ASIA Admission",
    description: "Venture into an immersive rainforest...",
    price: "From S$86.00",
    image: "1.jpg",
    label: "Local and Tourist Exclusive Opening Promotions"
  },
  {
    title: "Rainforest Wild ASIA - Wild Apex Adventure",
    description: "Embark on an exhilarating harnessed...",
    price: "From S$86.00",
    image: "2.jpg",
    label: "Local and Tourist Exclusive Opening Promotions"
  },
  {
    title: "Rainforest Wild ASIA - Wild Cavern",
    description: "Illuminated by headlamps, your...",
    price: "From S$86.00",
    image: "3.jpg",
    label: "Local and Tourist Exclusive Opening Promotions"
  },
  {
    title: "Rainforest Wild ASIA - AIA Vitality Bounce",
    description: "Enjoy our AIA Vitality Bounce experience for...",
    price: "From S$86.00",
    image: "4.jpg",
    label: "[Tourist Online Exclusive] 12 Feb - 7 May 2025"
  },
  {
    title: "Up to 20% off Singapore Zoo + Breakfast in the Wild",
    description: "Explore the world's best rainforest zoo —",
    price: "From S$86.80",
    image: "5.jpg"
  }
];

export default function TicketPage() {
  const navigate = useNavigate();

  return (
    <div className="bg-[#f9f5eb] min-h-screen md:px-52 font-georgia p-4 sm:p-6">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-4 sm:mb-6 sm:gap-4">
        
        <div className="hidden md:flex-wrap md:gap-2 md:flex sm:gap-4">
          <button className="px-3 py-2 text-sm bg-white rounded-full shadow sm:px-4 sm:text-base">Location ▼</button>
          <button className="px-3 py-2 text-sm bg-white rounded-full shadow sm:px-4 sm:text-base">Visitor Type ▼</button>
          <button className="px-3 py-2 text-sm bg-white rounded-full shadow sm:px-4 sm:text-base">Ticket Type ▼</button>
        </div>
        
        <button className="px-6 py-2 text-sm text-white bg-[#003400] font-semibold rounded-full sm:px-4 sm:text-base">Most Popular ▼</button>
      </div>
      <div className="grid grid-cols-1 gap-4 sm:gap-6 sm:grid-cols-2 md:grid-cols-3">
        {tickets.map((ticket, index) => (
          <div onClick={() => navigate('/1')} key={index} className="overflow-hidden bg-white shadow-lg rounded-2xl">
            <div className="relative">
              <img src={ticket.image} alt={ticket.title} className="object-cover w-full h-40 sm:h-48" />
              {ticket.label && (
                <div className="absolute px-2 py-1 text-xs font-bold text-black bg-yellow-500 rounded-md sm:px-3 sm:text-sm top-2 left-2">
                  {ticket.label}
                </div>
              )}
            </div>
            <div className="p-3 sm:p-4">
              <h3 className="text-lg font-bold text-green-900 sm:text-xl">{ticket.title}</h3>
              <p className="mt-2 text-xs text-gray-600 sm:text-sm">{ticket.description}</p>
              <p className="mt-3 font-semibold text-green-800 sm:mt-4">{ticket.price}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
